// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"314":"b6ccb658","496":"ba0953ec","653":"865c156d","718":"2d2efbc4","756":"1df11a0c","963":"7ee47192","977":"58e464a2"}[chunkId] + ".js";
};